import React from 'react';
import Styles from './footer.module.scss'
import { Heading, Image, ListGroup, ListItem, Text } from '../../shared';
import { getBasePath } from '../../../helper';
import { Link, NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const basePath = getBasePath();
  const navigate = useNavigate();

  const handleNavigation = (page) => {
    window.scrollTo(0, 0);

    if(page === 'Home') {
        navigate('/');
    }
    if(page === 'About') {
        navigate('/about');
    }
    if(page === 'Services') {
        navigate('/service');
    }
    if(page === 'Portfolio') {
        navigate('/portfolio');
    }
    if(page === 'Careers') {
        navigate('/careers');
    }
    if(page === 'Contact') {
        navigate('/contact');
    }
    if(page === 'Terms and Conditions') {
      navigate('/tnc');
    }
    if(page === 'Privacy Policy') {
      navigate('/pp');
    }
    if(page === 'Refund Policy') {
      navigate('/rp');
    }
    if(page === 'Blogs'){
      navigate('/blogs')
    }
    if(page === 'software-web-development') {
      navigate('/service/software-web-development');
  }
  if(page === 'social-media-optimization') {
      navigate('/service/social-media-optimization');
  }
  if(page === 'seo-services') {
      navigate('/service/seo-services');
  }
  if(page === 'paid-marketing') {
      navigate('/service/paid-marketing');
  }
  if(page === 'marketplace-management') {
      navigate('/service/marketplace-management');
  }
  if(page === 'whatsapp-services') {
      navigate('/service/whatsapp-services');
  }
  if(page === 'content-marketing') {
      navigate('/service/content-marketing');
  }
  if(page === 'graphics-designs') {
      navigate('/service/graphics-designs');
  }
  if(page === 'editing') {
      navigate('/service/editing');
  }
  if(page === 'saas') {
      navigate('/service/saas');
  }
  }

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }
  return (
    <div className={`${Styles.footer}`}>
      <Link to={'https://api.whatsapp.com/send?phone=7773882021'} target='_' className={Styles.whatsappChat}> <Image src={`${basePath}images/whatsapp.png`} /></Link>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-4 col-md-12 mb-3'>
            <Image src={`${basePath}images/logo-white.svg`} />
            <div className={`${Styles.aboutText} mt-3`}>
              <Text variant={'sm'} color={'white'} strong={'regular'}>UpSpot is a MarTech solutions company that helps businesses leverage technology to achieve their goals. We bridge the gap between adopting the right marketing strategies and processing way too much ease with the core objective being agility and personalisation.</Text>
            </div>
          </div>
          <div className='col-lg-2 col-md-6'>
            <Heading headingType={'h3'} headingText={'Quick Links'} color={'primaryLight'} strong={'regular'} />
            <ListGroup className={Styles.footerMenu}>
              <ListItem onClick={() => handleNavigation('Home')}><Text variant={'md'} color={'white'} strong={'regular'}>Home</Text></ListItem>
              <ListItem onClick={() => handleNavigation('About')}><Text variant={'md'} color={'white'} strong={'regular'}>About us</Text></ListItem>
              <ListItem onClick={() => handleNavigation('Services')}><Text variant={'md'} color={'white'} strong={'regular'}>Services</Text></ListItem>
              {/* <ListItem onClick={() => handleNavigation('Portfolio')}><Text variant={'md'} color={'white'} strong={'regular'}>Portfolio</Text></ListItem> */}
              <ListItem onClick={() => handleNavigation('Careers')}><Text variant={'md'} color={'white'} strong={'regular'}>Careers</Text></ListItem>
              <ListItem onClick={() => handleNavigation('Blogs')}><Text variant={'md'} color={'white'} strong={'regular'}>Blogs</Text></ListItem>
              <ListItem onClick={() => handleNavigation('Contact')}><Text variant={'md'} color={'white'} strong={'regular'}>Contact us</Text></ListItem>
              <ListItem onClick={() => handleNavigation('Terms and Conditions')}><Text variant={'md'} color={'white'} strong={'regular'}>Terms and Conditions</Text></ListItem>
              <ListItem onClick={() => handleNavigation('Privacy Policy')}><Text variant={'md'} color={'white'} strong={'regular'}>Privacy Policy</Text></ListItem>
              <ListItem onClick={() => handleNavigation('Refund Policy')}><Text variant={'md'} color={'white'} strong={'regular'}>Refund Policy</Text></ListItem>
            </ListGroup>
          </div>
          <div className='col-lg-3 col-md-6'>
            <Heading headingType={'h3'} headingText={'Services'} color={'primaryLight'} strong={'regular'} />
            <ListGroup className={Styles.footerMenu}>
              <ListItem onClick={() => handleNavigation('software-web-development')}><Text variant={'md'} color={'white'} strong={'regular'}>Software/Web Development</Text></ListItem>
              <ListItem onClick={() => handleNavigation('social-media-optimization')}><Text variant={'md'} color={'white'} strong={'regular'}>Social Media Optimization</Text></ListItem>
              <ListItem onClick={() => handleNavigation('seo-services')}><Text variant={'md'} color={'white'} strong={'regular'}>Seo Services</Text></ListItem>
              {/* <ListItem onClick={() => handleNavigation('Portfolio')}><Text variant={'md'} color={'white'} strong={'regular'}>Portfolio</Text></ListItem> */}
              <ListItem onClick={() => handleNavigation('paid-marketing')}><Text variant={'md'} color={'white'} strong={'regular'}>Paid Marketing</Text></ListItem>
              <ListItem onClick={() => handleNavigation('marketplace-management')}><Text variant={'md'} color={'white'} strong={'regular'}>Marketplace Management</Text></ListItem>
              <ListItem onClick={() => handleNavigation('whatsapp-services')}><Text variant={'md'} color={'white'} strong={'regular'}>WhatsApp Services</Text></ListItem>
              <ListItem onClick={() => handleNavigation('content-marketing')}><Text variant={'md'} color={'white'} strong={'regular'}>Content Marketing</Text></ListItem>
              <ListItem onClick={() => handleNavigation('editing')}><Text variant={'md'} color={'white'} strong={'regular'}>Video and Photo Shoots/ Editing</Text></ListItem>
              <ListItem onClick={() => handleNavigation('graphics-designs')}><Text variant={'md'} color={'white'} strong={'regular'}>Graphics Designs</Text></ListItem>
            </ListGroup>
          </div>
          <div className='col-lg-3 col-md-6'>
            <Heading headingType={'h3'} headingText={'Contact us'} color={'primaryLight'} strong={'regular'} />
            <div><Text variant={'sm'} color={'white'} strong={'regular'}>It's very easy to get in touch with us. Just use the contact form or pay us a visit for a coffee at the office.</Text></div>
            <div className='mt-2'><Text variant={'md'} color={'white'} strong={'regular'}><Link to="mailto:coffee@upspot.in">coffee@upspot.in</Link></Text></div>
            <div className='mt-2'><Text variant={'md'} color={'white'} strong={'regular'}><Link to="tel:+918518006091">+91 85180 06091</Link></Text></div>
            <ListGroup className={Styles.social}>
              <ListItem><NavLink to={'https://www.facebook.com/ketanshah01/'} target='_'><Image src={`${basePath}images/facebook.svg`} /></NavLink></ListItem>
              <ListItem><NavLink to={'https://www.instagram.com/upspotindia/'} target='_'><Image src={`${basePath}images/instagram.svg`} /></NavLink></ListItem>
              <ListItem><NavLink to={'https://twitter.com/upspotindia'} target='_'><Image src={`${basePath}images/x.svg`} /></NavLink></ListItem>
              <ListItem><NavLink to={'https://www.linkedin.com/company/upspotdotin/'} target='_'><Image src={`${basePath}images/linkedin.svg`} /></NavLink></ListItem>
            </ListGroup>
          </div>
        </div>
      </div>
      <div className={`mt-3 pt-3 text-center px-3 ${Styles.copyright}`}><Text variant={'md'} color={'white'} strong={'regular'}>Copyright © {getCurrentYear()} UpSpot. All Rights Reserved.</Text></div>
    </div>
  )
}

export default Footer